export function escapeMailComposeHtml(value: string): string {
  return value
    .replace(/&/gu, '&amp;')
    .replace(/</gu, '&lt;')
    .replace(/>/gu, '&gt;')
    .replace(/"/gu, '&quot;')
    .replace(/'/gu, '&#39;');
}

export function mailComposeTextToHtml(value: string): string | null {
  if (!value.trim()) return null;
  return value
    .replace(/\r\n?/gu, '\n')
    .split(/\n{2,}/gu)
    .map(paragraph => {
      const html = escapeMailComposeHtml(paragraph).replace(/\n/gu, '<br>');
      return `<p>${html || '<br>'}</p>`;
    })
    .join('');
}
